import React from 'react';
import Typography from '@johnlewispartnership/wtr-ingredients/foundations/typography';
import { type BannerV3 } from 'api/definitions/adtech/types';
import { useAdtechObserver } from 'components/adtech/use-adtech-observer';
import { sendAdTechEvent } from 'analytics/gtmServerFunctions';
import { useSelector } from 'redux/hooks';
import { selectHotspots } from 'redux/modules/banners/selectors';
import { getBannerUrl } from 'utils/adtech/generate-banner-link';
import styles from './OffersHotspots.scss';

const Hotspot = ({ banner: { id, textArea, image, tracking, products } }: { banner: BannerV3 }) => (
  <li>
    <a
      ref={useAdtechObserver(id, tracking)}
      href={getBannerUrl(textArea.link.url, products)}
      target={textArea.link.isExternalLink ? '_blank' : undefined}
      rel={textArea.link.isExternalLink ? 'noopener noreferrer' : undefined}
      onClick={() => {
        sendAdTechEvent({
          eventType: 'click',
          sponsorshipId: id,
          trackingUrls: tracking.clickUrls,
          vendor: tracking.vendor,
        });
      }}
    >
      <img src={image.src} alt={image.altText} />
      <Typography
        element="span"
        className={styles.offer}
        styleAs="sectionHeading"
        textStyle="heading-xl"
      >
        {textArea.heading}
      </Typography>
      <Typography element="span" styleAs="paragraphHeading" textStyle="heading-l">
        {textArea.subheading}
      </Typography>
    </a>
  </li>
);

export const OffersHotspots = () => {
  const banners = useSelector(selectHotspots);

  return (
    <div className="container-fluid">
      <nav id="offers-hotspots" aria-label="Special offers" className={styles.hotspots}>
        <ul>
          {banners.map(banner => (
            <Hotspot banner={banner} key={banner.id} />
          ))}
        </ul>
      </nav>
    </div>
  );
};
